// frontend/klaes-app/src/components/FilmFavs/components/BatteryIndicator.jsx
import { getBatteryLevel } from '../utils/helpers';
import { styles } from '../styles';

export const BatteryIndicator = ({ rating, onClick, isUserRating = false, pulsate = false }) => {
  const numericRating = typeof rating === 'number' ? rating : parseFloat(rating) || 0;
  const { level, color } = getBatteryLevel(numericRating);

  return (
    <div 
      className={`${styles.compBattery} ${isUserRating ? styles.compUserBattery : ''} ${pulsate ? styles.compPulsate : ''}`} 
      onClick={onClick}
    >
      <div className={styles.compBatteryContainer}>
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className={`${styles.compBatteryCell} ${i < level ? styles[`${color}Filled`] : styles.empty}`}
          />
        ))}
        <div className={styles.compBatteryCap} />
      </div>
      <span className={styles.compBatteryRating}>{numericRating.toFixed(1)}%</span>
    </div>
  );
};